import {
  ButtonActionType,
  DocumentActionType,
  NominatedAccountStatusEnum,
  UiZoneWidgetAttributeConfig,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { Observable, take, tap } from 'rxjs';
import { GetNominatedAccountStatus } from '../../../actions/savings-account.action';
import { ConfigService } from '../../../services/config-service/config-service.service';
import { CtaButtonSignalService } from '../../../services/cta-button-signal-service/cta-button-signal.service';
import { SavingsAccountState } from '../../../state/savings-account.state';
import { bulkPaymentApproveRejectButtonStatus } from '../bulk-payments/bulk-payments.utils';
import {
  transactionUploadDocumentHide,
  transactionViewDocumentHide,
} from '../transaction-receipt/transaction-receipt';

let goCardlessScriptAdded = false;

export const ctaButtonShowHideMap: Map<
  ButtonActionType,
  (
    store: Store,
    ctaButtonSignalService: CtaButtonSignalService,
    attri?: UiZoneWidgetAttributeConfig,
    configService?: ConfigService,
  ) => Observable<any>
> = new Map<ButtonActionType, any>([
  [
    ButtonActionType.BULK_PAYMENT_APPROVER,
    (
      store: Store,
      ctaButtonSignalService: CtaButtonSignalService,
      attri: UiZoneWidgetAttributeConfig,
      configService: ConfigService,
    ) => {
      bulkPaymentApproveRejectButtonStatus(store, ctaButtonSignalService, attri, configService);
    },
  ],
  [
    ButtonActionType.BULK_PAYMENT_REJECT,
    (
      store: Store,
      ctaButtonSignalService: CtaButtonSignalService,
      attri: UiZoneWidgetAttributeConfig,
      configService: ConfigService,
    ) => {
      bulkPaymentApproveRejectButtonStatus(store, ctaButtonSignalService, attri, configService);
    },
  ],
  [
    ButtonActionType.UPLOAD_DOCUMENT,
    (
      store: Store,
      ctaButtonSignalService: CtaButtonSignalService,
      attri: UiZoneWidgetAttributeConfig,
      configService: ConfigService,
    ) => {
      if (attri?.['documentActionType'] === DocumentActionType.TRANSACTIONS) {
        transactionUploadDocumentHide(store, ctaButtonSignalService, attri, configService);
      }
    },
  ],
  [
    ButtonActionType.VIEW_DOCUMENT,
    (
      store: Store,
      ctaButtonSignalService: CtaButtonSignalService,
      attri: UiZoneWidgetAttributeConfig,
      configService: ConfigService,
    ) => {
      if (attri?.['documentActionType'] === DocumentActionType.TRANSACTIONS) {
        transactionViewDocumentHide(store, ctaButtonSignalService, attri, configService);
      }
    },
  ],
  [
    ButtonActionType.PISP_DEPOSIT,
    (store: Store, ctaButtonSignalService: CtaButtonSignalService, attri: UiZoneWidgetAttributeConfig) => {
      store
        .select(SavingsAccountState.getAccounts)
        .pipe(
          take(1),
          tap((savinsAccountState) => {
            if (!savinsAccountState.nominatedAccountStatus) store.dispatch(new GetNominatedAccountStatus());
            const isNominatedAccountConnected =
              savinsAccountState.nominatedAccountStatus &&
              savinsAccountState.nominatedAccountStatus === NominatedAccountStatusEnum.CONNECTED;
            const shouldShowButton = !!(
              isNominatedAccountConnected && savinsAccountState.nominatedAccountId?.length
            );
            if (shouldShowButton && !goCardlessScriptAdded) {
              const existingScript =
                document.getElementById('gocardless-dropin-initializer') ||
                document.querySelector('script[src*="gocardless.com/billing/static/dropin"]');

              if (!existingScript) {
                const script = document.createElement('script');
                script.id = 'gocardless-dropin-initializer';
                script.src = 'https://pay.gocardless.com/billing/static/dropin/v2/initialise.js';
                script.type = 'text/javascript';
                document.body.appendChild(script);
                goCardlessScriptAdded = true;
              } else {
                goCardlessScriptAdded = true;
              }
            }
            ctaButtonSignalService.setHideButtonSignal({
              [attri?.['buttonActionType']]: !shouldShowButton,
            });
          }),
        )
        .subscribe();
    },
  ],
]);
